import {
  Box,
} from '@mui/material';
import LimiterInput from './LimiterInput';
import { InputLimits } from '../../../../enums/InputLimits';

function SEOSetting(props: {
  headerScript: string,
  bodyScript: string,
  onHeaderScriptChange: (value: string) => void,
  onBodyScriptChange: (value: string) => void,
}) {
  const {
    headerScript,
    bodyScript,
    onHeaderScriptChange,
    onBodyScriptChange,
  } = props;
  return (
    <Box display="flex" flexDirection="column" rowGap="10px">
      <div className="col-form-label text-bold">タグの埋め込み</div>
      <p className="mb-2">ページのheadタグ内、body直下にお好きなタグを埋め込めます。</p>

      <div className="row my-3">
        <div className="col-lg-9">
          <LimiterInput
            textarea
            label="headタグ直下の埋め込み"
            limit={InputLimits.SEO_HEADER_SCRIPT}
            value={headerScript || ''}
            placeholder="タグは</head>の直前に埋め込みされます。"
            onChange={(newValue) => onHeaderScriptChange(newValue)}
          />
          <div className="text-sm">※headヘッダ内に埋め込めるタグは、&lt;meta&gt; &lt;script&gt; &lt;style&gt; &lt;link&gt; &lt;noscript&gt; &lt;!----&gt;のみとなります。</div>
        </div>

        <div className="col-lg-3">
          <div className="d-flex flex-column">
            <div className="my-2">※埋め込みタグ例</div>
            <div>・Googleマネージャー</div>
            <div>・Facebookピクセル</div>
          </div>
        </div>
      </div>

      <div className="row my-3">
        <div className="col-lg-9">
          <LimiterInput
            textarea
            label="bodyタグ直下の埋め込み"
            limit={InputLimits.SEO_BODY_SCRIPT}
            value={bodyScript || ''}
            placeholder="タグは</body>の直前に埋め込みされます。"
            onChange={(newValue) => onBodyScriptChange(newValue)}
          />
          <div className="text-sm">※bodyタグ直下に埋め込めるタグは、&lt;script&gt; &lt;style&gt; &lt;link&gt; &lt;noscript&gt; &lt;!----&gt;のみとなります。</div>
        </div>

        <div className="col-lg-3">
          <div className="d-flex flex-column">
            <div className="my-2">※埋め込みタグ例</div>
            <div>・Googleマネージャー</div>
            <div>・Yahoo!タグマネージャー</div>
          </div>
        </div>
      </div>
    </Box>
  );
}

export default SEOSetting;
